import { Language } from "../../model/rsvp";

export function getPrettyPrimaryFontClass(language: Language): string {
  if (language === "ko") {
    return "font-pretty-primary-ko";
  } else {
    return "font-pretty-primary";
  }
}

export function getPrettySecondaryFontClass(language: Language): string {
  if (language === "ko") {
    return "font-pretty-secondary-ko";
  } else {
    return "font-pretty-secondary";
  }
}

export function getHomeFontClass(language: Language): string {
  if (language === "ko") {
    return "font-home-ko";
  } else {
    return "font-home";
  }
}

export function getStoryFontClass(language: Language): string {
  if (language === "ko") {
    return "font-story-ko";
  } else {
    return "font-story";
  }
}
